module.exports = __webpack_public_path__ + "img/tatsing-global-trading-logo(White Text).212fe127.png";